import styles from './Billing.module.sass'
import StripeBilling from 'components/Stripe'

function BillingPage() {
  return (
    <div className={styles.container}>
      <StripeBilling />
    </div>
  )
}

export default BillingPage
